import { Sun, Moon, Download } from "lucide-react";

export default function Navbar({ lightMode, setlightMode }) {
  return (
    <nav className="sticky top-0 z-50 border-b border-gray-200/30 light:bg-white/70 backdrop-blur-xl dark:border-gray-800 dark:bg-gray-950/70">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-10">

        {/* Logo */}
        <a
          href="#home"
          className="text-2xl font-bold tracking-tight text-emerald-600 transition hover:text-emerald-500"
        >
          Sujita Regmi
        </a>

        {/* Navigation */}
        <ul className="hidden items-center gap-8 md:flex">

          <li>
            <a
              href="#home"
              className="relative text-sm font-medium text-gray-700 transition hover:text-emerald-600 dark:text-gray-300 dark:hover:text-emerald-400 after:absolute after:-bottom-1 after:left-0 after:h-0.5 after:w-0 after:bg-emerald-500 after:transition-all after:duration-300 hover:after:w-full"
            >
              Home
            </a>
          </li>

          <li>
            <a
              href="#projects"
              className="relative text-sm font-medium text-gray-700 transition hover:text-emerald-600 dark:text-gray-300 dark:hover:text-emerald-400 after:absolute after:-bottom-1 after:left-0 after:h-0.5 after:w-0 after:bg-emerald-500 after:transition-all after:duration-300 hover:after:w-full"
            >
              Work
            </a>
          </li>

          <li>
            <a
              href="#journey"
              className="relative text-sm font-medium text-gray-700 transition hover:text-emerald-600 dark:text-gray-300 dark:hover:text-emerald-400 after:absolute after:-bottom-1 after:left-0 after:h-0.5 after:w-0 after:bg-emerald-500 after:transition-all after:duration-300 hover:after:w-full"
            >
              Journey
            </a>
          </li>

          <li>
            <a
              href="#contact"
              className="relative text-sm font-medium text-gray-700 transition hover:text-emerald-600 dark:text-gray-300 dark:hover:text-emerald-400 after:absolute after:-bottom-1 after:left-0 after:h-0.5 after:w-0 after:bg-emerald-500 after:transition-all after:duration-300 hover:after:w-full"
            >
              Contact
            </a>
          </li>

        </ul>

        {/* Right Side */}
        <div className="flex items-center gap-3">

          <a
            href="/Resume.pdf"
            download
            className="hidden items-center gap-2 rounded-xl border border-emerald-500 px-4 py-2 text-sm font-medium text-emerald-600 transition-all duration-300 hover:bg-emerald-500 hover:text-white md:flex"
          >
            <Download size={16} />
            Resume
          </a>

          <button
            onClick={() => setlightMode(!lightMode)}
            className="rounded-xl p-2 transition hover:bg-emerald-100 dark:hover:bg-gray-800"
          >
            {lightMode ?  <Sun size={20}/>: <Moon size={20}   />}
          </button>

        </div>

      </div>
    </nav>
  );
}